import styled from 'styled-components'

const StyledFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`

export default StyledFlexRow
